<template>
    <div>
        <img class="bgLight" src="@/assets/theme/light2.png" alt="">
        <div class="sprite-animation"></div>
    </div>

</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

const startAnimation = ref(false);

onMounted(() => {
    setTimeout(() => {
        startAnimation.value = true;
    }, 100);
});
</script>

<style scoped>
.bgLight {
    width: 85%;
    position: relative;
    animation: rotateBg 5s linear infinite;
}

.sprite-animation {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%) scale(0.6);
    width: 304px;
    height: 353px;
    background-image: url('@/assets/theme/wait-ani.png');
    animation-name: sprite;
    animation-duration: 1.5s;
    animation-timing-function: steps(14);
    animation-iteration-count: infinite;
}

@keyframes sprite {
    from {
        background-position: 0px;
    }

    to {
        background-position: -4256px;
    }
}

@keyframes rotateBg {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
